/* @ngInject */
function AssetPreviewTabCommentsController ($scope, $attrs, $rootScope, $timeout, $translate, $window, TasksService, ToastService, SegmentService, ArtsService, ApprovalsService, BannerService, Utils) {
  $scope.attachment = {}
  $scope.comments = []

  $scope.flags = {
    reset: false
  }

  $scope.chat = {
    type: 'public',
    hasPrivate: false,
    updateComments: false,
    pin: null,
    focused: false
  }

  const api = {
    _initializeAttachmentComments,
    _initializeArtComments,
    _isImage,
    _resetForm,
    _getAttachmentComments,
    _handleCommentsPins,
    _removePin,
    _loadTaskAttachmentPins,
    _getPinData,
    _onSaveSuccess,
    _handlePreviewImageClick,
    _handlePreviewVideoClick,
    _handlePreviewPdfClick,
    _saveAttachmentComment,
    _saveArtComment,
    _getApprovalComments,
    _handleArtCommentsPins,
    _handleRequestAttachmentEditComment,
    _handleArtEditComment,
    _showPrivateTab,
    _showMarkImage,
    _getChatHandlers,
    _deleteAttachmentComment,
    _deleteArtComment,
    _parseCommentResponse,
    _reloadWorkflowData,
    _handleCommentsContentMaxHeight,
    _moveApprovalToAdjust,
    _successMoveApprovalToAdjust,
    _errorMoveApprovalToAdjust,
    _isPrivateAsset,
    _removeCommentPin
  }
  this.getApi = () => api

  const handleCommentsContentMaxHeightDebounce = Utils.debounce(api._handleCommentsContentMaxHeight)

  activate()
  function activate () {
    $window.addEventListener('resize', handleCommentsContentMaxHeightDebounce)
  }

  $scope.$watchCollection('template', () => {
    $scope.previewFlags.onPreviewPdfClick = api._handlePreviewPdfClick
    $scope.previewFlags.onPreviewImageClick = api._handlePreviewImageClick
    $scope.previewFlags.onPreviewVideoClick = api._handlePreviewVideoClick

    $timeout(() => {
      const { initialize } = api._getChatHandlers($scope.location)
      $scope.previewFlags.tabHasNewComment = false
      initialize()
    }, 100, true)

    $scope.chat.updateComments = true
  })

  $scope.$watchCollection('previewFlags.selectedLayerId', () => {
    const { loadPins } = api._getChatHandlers($scope.location)
    loadPins()
  })

  $scope.$watch('previewFlags.isAddingAnnotation', () => {
    if ($scope.previewFlags.isAddingAnnotation) {
      $scope.chat.alwaysFocused = true
    }
  })

  function _initializeArtComments () {
    api._showMarkImage()
  }

  function _initializeAttachmentComments () {
    if (!$scope.attachment.task_has_asset && $scope.attachment.tasks) {
      $scope.attachment.task_has_asset = $scope.attachment.tasks[0].task_has_asset
    }

    api._showPrivateTab()
    api._showMarkImage()
  }

  const deregisterPreviewReloadComments = $rootScope.$on('asset-preview.reloadComments', () => {
    $scope.chat.updateComments = true
  })

  $scope.$on('$destroy', function () {
    $window.removeEventListener('resize', handleCommentsContentMaxHeightDebounce)
    $scope.previewFlags.commentsPins = []
    $scope.previewFlags.temporaryPin = null
    $scope.previewFlags.showImageZoomControls = true
    $scope.previewFlags.onPreviewImageClick = () => {}
    $scope.previewFlags.onPreviewVideoClick = () => {}
    $scope.previewFlags.videoPlayer = null
    $scope.previewFlags.showVideoPin = null
    deregisterPreviewReloadComments()
  })

  $scope.handleSaveComment = function (comment) {
    const { save } = api._getChatHandlers($scope.location)
    return save(comment)
  }

  $scope.handleDeleteComment = (comment) => {
    const { del } = api._getChatHandlers($scope.location)
    return del(comment)
  }

  $scope.handleEditComment = function (comment) {
    const { edit } = api._getChatHandlers($scope.location)
    return edit(comment)
  }

  $scope.getComments = (limit, offset, filter) => {
    const { loadComments } = api._getChatHandlers($scope.location)
    return loadComments(limit, offset, filter)
  }

  $scope.handleCommentsContentMaxHeight = api._handleCommentsContentMaxHeight

  function _saveAttachmentComment (comment) {
    const { isRequestingChanges, temporaryPin } = $scope.previewFlags
    const assetId = $scope.attachment.id
    const taskId = $scope.contextData.task.id || $scope.contextData.task.taskId
    const originType = $scope.contextData.task.originType
    const internalApproval = $scope.contextData.internalApproval

    const isPrivateAsset = api._isPrivateAsset($scope.attachment, $scope.contextData.task)

    const messagePin = temporaryPin
    const messageUserIds = comment.userIds
    const messageValue = comment.value
    const isRequestingAdjustToMaterial = internalApproval && messagePin && isRequestingChanges
    const messageIsPrivate = isRequestingAdjustToMaterial || isPrivateAsset || comment.type === 'private'

    if (isRequestingAdjustToMaterial) {
      $scope.previewFlags.isRequestingChanges = false
      api._moveApprovalToAdjust(internalApproval, assetId, taskId, messageValue)
    }

    return TasksService
      .addAssetComment(assetId, taskId, messageValue, messageIsPrivate, messagePin, messageUserIds)
      .then(() => {
        SegmentService.track('added-comment', { private: messageIsPrivate, task_id: taskId, asset_id: assetId, type: originType })
      })
      .then(api._onSaveSuccess)
      .then(api._reloadWorkflowData)
      .catch(ToastService.defaultErrorToast)
  }

  function _saveArtComment (comment) {
    const { selectedLayerId, temporaryPin } = $scope.previewFlags
    const artId = $scope.template.id
    const payload = {
      message: comment.value
    }

    if (temporaryPin) {
      payload.pin = {
        x: temporaryPin.x,
        y: temporaryPin.y,
        artLayerId: selectedLayerId,
        timestampMs: temporaryPin?.timestampMs,
        pageNumber: temporaryPin?.pageNumber
      }
    }

    return ArtsService.addCommentToArt(artId, payload).then(() => {
      api._resetForm()
    }).then(() => {
      $scope.chat.updateComments = true
      $timeout(() => {
        $scope.previewFlags.isAddingAnnotation = false
        $scope.previewFlags.temporaryPin = null
      }, 0, true)
    })
  }

  function _handleRequestAttachmentEditComment (comment) {
    const messageId = comment.message.id
    const messageValue = comment.newMessage.value
    const messagePin = comment.message.assetCommentPin
    const messageIsPrivate = comment.newMessage.type === 'private'
    const messageUserIds = comment.newMessage.userIds

    return TasksService
      .editAssetComment(messageId, messageValue, messageIsPrivate, messagePin, messageUserIds)
      .then(api._onSaveSuccess)
      .then(api._reloadWorkflowData)
      .catch(ToastService.defaultErrorToast)
  }

  function _handleArtEditComment (comment) {
    const artId = $scope.template.id
    return ArtsService.updateComment(artId, { message: comment.newMessage.value, commentId: comment.message.id })
  }

  function _isImage () {
    if ($scope.location === 'materialsApproval') {
      return true
    }

    const imageExtensions = ['png', 'jpg', 'jpeg', 'webp', 'tiff', 'tif', 'gif', 'svg', 'ai', 'psd', 'image/png', 'image/jpeg', 'image/jpg', 'application/postscript', 'image/jpg', 'image/vnd.adobe.photoshop', 'image/psd']
    const extension = $scope.attachment.extension
    return imageExtensions.includes(extension)
  }

  function _resetForm () {
    $scope.previewFlags.isAddingAnnotation = false
  }

  function _loadTaskAttachmentPins () {
    const assetId = $scope?.attachment?.id || $scope?.template?.id

    if (!assetId) return

    TasksService.getAssetPins(assetId).then((pins) => {
      $timeout(() => {
        $scope.previewFlags.commentsPins = pins
      }, 0, true)
    })
  }

  function _getApprovalComments (id, limit, offset) {
    return ArtsService.getArtApprovalComments(id, limit, offset).then(api._parseCommentResponse)
  }

  function _getAttachmentComments (assetId, limit, offset, taskId) {
    return TasksService.getAssetComments(assetId, limit, offset, taskId).then(api._parseCommentResponse)
  }

  function _handleArtCommentsPins () {
    const { selectedLayerId } = $scope.previewFlags

    const pins = $scope?.comments
      .filter((comment) => comment.pin && comment.pin.artLayerId === selectedLayerId)
      .map(comment => {
        const approvalComment = { authorId: comment.user.id }
        const pin = {
          ...comment.pin,
          approvalComment
        }

        return pin
      })

    $scope.previewFlags.commentsPins = pins
  }

  function _onSaveSuccess () {
    $scope.flags.reset = true
    $scope.chat.updateComments = true
    $timeout(() => {
      $scope.previewFlags.isAddingAnnotation = false
      $scope.previewFlags.temporaryPin = null
    }, 0, true)
  }

  function _removePin (pin) {
    const index = $scope.previewFlags.commentsPins
      .findIndex(item => +item.x === +pin.x && +item.y === +pin.y)
    if (index >= 0) {
      $scope.previewFlags.commentsPins.splice(index, 1)
    }
  }

  function _focusInputRichText () {
    const inputRichTextContainer = $attrs.$$element.find('.input-rich-text-container')[0]
    const editorElement = inputRichTextContainer.querySelector('.input-rich-text__editor')
    const inputRichText = editorElement.querySelector('.ql-editor')
    if (inputRichText) inputRichText.focus()
  }

  function _handlePreviewPdfClick (e, pdfPageNumber) {
    if ($scope.previewFlags.isAddingAnnotation) {
      const canvas = document.querySelector('#previewCanvaMain')
      if (!canvas) return null
      const rect = canvas.getBoundingClientRect()
      const pinOffset = 4
      const x = e.clientX - rect.left + pinOffset
      const y = e.clientY - rect.top - pinOffset
      const pin = {
        x,
        y,
        assetComment: { authorId: $rootScope.oUser.id },
        pageNumber: pdfPageNumber
      }
      $scope.previewFlags.temporaryPin = pin
      $scope.chat.pin = pin
      $timeout(() => {
        _focusInputRichText()
      })
    }
  }

  function _handlePreviewImageClick (e) {
    if ($scope.previewFlags.isAddingAnnotation) {
      const pin = api._getPinData(e)

      $scope.previewFlags.temporaryPin = pin
      $scope.chat.pin = pin
      $timeout(() => {
        _focusInputRichText()
      })
    }
  }

  function _handlePreviewVideoClick (e, player) {
    if ($scope.previewFlags.isAddingAnnotation) {
      player.pause()

      const pin = api._getPinData(e)
      pin.timestampMs = parseInt(player.currentTime)
      $scope.previewFlags.temporaryPin = pin
      $scope.chat.pin = pin
      $timeout(() => {
        _focusInputRichText()
      })
    }
  }

  function _getPinData (e) {
    const rect = e.target.getBoundingClientRect()
    const pinOffset = 4
    const x = e.clientX - rect.left + pinOffset
    const y = e.clientY - rect.top - pinOffset

    const assetComment = { authorId: $rootScope.oUser.id }

    return { x, y, assetComment }
  }

  $scope.onPinTimeClick = (message) => {
    const { pin } = message

    if (pin) {
      const { videoPlayer } = $scope.previewFlags
      const clickedPin = $scope.previewFlags.commentsPins.find(loadedPin => pin.id === loadedPin.id)
      $scope.previewFlags.videoPin = clickedPin

      if (videoPlayer) {
        videoPlayer.currentTime = clickedPin.timestampMs
        $timeout(() => {
          videoPlayer.pause()
          $scope.previewFlags.videoCanPlay = false
        }, 5)
      }
    }
  }

  function _showPrivateTab () {
    const isNotPrivateAsset = $scope.attachment?.task_has_asset && !$scope.attachment?.task_has_asset?.isPrivate
    const isAdminDesigner = $rootScope.isUserSysAdminAdminDesigner()

    if (isAdminDesigner && isNotPrivateAsset) {
      $scope.chat.hasPrivate = true
      return
    }

    $scope.chat.hasPrivate = false
  }

  function _showMarkImage () {
    if (api._isImage()) {
      $scope.chat.hasMark = true
      $scope.chat.isMark = false
      return
    }

    $scope.chat.hasMark = false
  }

  function _getChatHandlers (location) {
    const materialHandlers = {
      save: api._saveArtComment,
      edit: api._handleArtEditComment,
      del: api._deleteArtComment,
      initialize: api._initializeArtComments,
      loadPins: api._handleArtCommentsPins,
      loadComments: (limit, offset) => api._getApprovalComments($scope.template.id, limit, offset)
    }
    const locations = {
      workflow: {
        save: api._saveAttachmentComment,
        edit: api._handleRequestAttachmentEditComment,
        del: api._deleteAttachmentComment,
        initialize: () => {
          $scope.attachment = $scope.template
          api._initializeAttachmentComments()
        },
        loadPins: _loadTaskAttachmentPins,
        loadComments: (limit, offset) => {
          const taskId = $scope.contextData.task.id || $scope.contextData.task.taskId
          return api._getAttachmentComments($scope.template.id, limit, offset, taskId)
        }
      },
      materialsApproval: materialHandlers,
      materialsCustomizations: materialHandlers
    }

    if (locations[String(location)]) return locations[String(location)]
  }

  function _removeCommentPin (comment) {
    const pinIndex = $scope.previewFlags.commentsPins.findIndex(pin =>
      pin.assetCommentId === comment.id || pin.assetComment?.id === comment.id
    )

    if (pinIndex >= 0) {
      $scope.previewFlags.commentsPins.splice(pinIndex, 1)
    }
  }

  function _deleteAttachmentComment (comment) {
    if (comment.assetCommentPin) {
      api._removeCommentPin(comment)
    }
    return TasksService.deleteAssetComment(comment.id).then(api._reloadWorkflowData)
  }

  function _deleteArtComment (comment) {
    if (comment.pin) {
      api._removeCommentPin(comment)
    }
    return ArtsService.deleteComment($scope.template.id, comment.id)
  }

  function _parseCommentResponse (response) {
    const rows = response?.d?.results || response.rows

    if (rows?.length) {
      rows.forEach(comment => {
        if (comment.to) {
          comment.value = comment.to

          if (comment.author) {
            comment.author.userId = comment.author.id
          }

          return
        }

        comment.value = comment.message
      })
    }

    $scope.comments = rows
    api._handleCommentsPins()

    return response
  }

  function _reloadWorkflowData () {
    $rootScope.$emit('workflow.reloadAttachments')
    $rootScope.$emit('workflow.reloadComments')
  }

  function _handleCommentsContentMaxHeight () {
    $timeout(() => {
      const container = $attrs.$$element.find('.asset-preview-tab-comments__chat')[0]
      const chatWrapper = $attrs.$$element.find('.asset-preview-tab-comments__chat chat .chat-container')[0]
      const chatWrapperHeight = container.getBoundingClientRect().height

      chatWrapper.style.maxHeight = `${chatWrapperHeight}px`
    }, 50, true)
  }

  function _moveApprovalToAdjust (internalApproval, assetId, taskId, reasonText) {
    const approvalId = internalApproval.id
    const status = 'ADJUST'

    ApprovalsService.updateApprovalAssetStatus(approvalId, assetId, status, reasonText)
      .then(() => api._successMoveApprovalToAdjust(approvalId, assetId, taskId, status))
      .catch(api._errorUpdateCommentApprovalWithPin)
  }

  function _successMoveApprovalToAdjust (approvalId, assetId, taskId, status) {
    $scope.chat.updateComments = true

    $rootScope.$emit('workflow.reloadComments')
    $rootScope.$emit('onDeleteAsset', {
      assetId,
      shouldClose: false,
      shouldOpenComments: true
    })

    BannerService.showBanner({
      type: 'neutral',
      bannerLabel: $translate.instant('adjustMaterial'),
      bannerIcon: 'check'
    }, true)

    SegmentService.track('workflow-internal-approve-attachment', {
      approval_status: status,
      internal_approval_id: approvalId,
      task_id: taskId,
      asset_id: assetId
    })
  }

  function _errorMoveApprovalToAdjust (error) {
    console.log({ error })
    ToastService.defaultErrorToast()
  }

  function _handleCommentsPins () {
    const { loadPins } = api._getChatHandlers($scope.location)
    loadPins()
  }

  function _isPrivateAsset (attachment, task) {
    const currentAsset = task.assets.find(asset => asset.id === attachment.id)
    return currentAsset?.task_has_asset?.isPrivate || false
  }
}

export { AssetPreviewTabCommentsController }
